// SellerAccountForm.tsx
import { Button, Step, StepLabel, Stepper } from "@mui/material";
import React, { useState } from "react";
import BecomeSellerFormStep1 from "./BecomeSellerFormStep1";
import { useFormik } from "formik";
import BecomeSellerFormStep2 from "./BecomeSellerFormStep2";
import BecomeSellerFormStep3 from "./BecomeSellerFormStep3";
import BecomeSellerFormStep4 from "./BecomeSellerFormStep4";
import { useAppDispatch } from "../../../State/Store"; // Make sure path matches your store setup
import { registerSeller } from "../../../State/seller/sellerAuthSlice";
import { useNavigate } from "react-router-dom";

const steps = [
    "Tax Details & Mobile",
    "Pickup Address",
    "Bank Details",
    "Supplier Details"
];

const SellerAccountForm = () => {
    const [activeStep, setActiveStep] = useState(0);
    const dispatch = useAppDispatch(); // Initialize dispatch
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            mobile: "",
            gstin: "",
            pickupAddress: { /* ... */ },
            bankDetails: { /* ... */ },
            sellerName: "",
            email: "",
            businessDetails: { /* ... */ },
            password: ""
        },
        onSubmit: (values) => {
            //console.log("Submitting registration:", values);
            // Dispatch with navigate payload
            dispatch(registerSeller({ sellerData: values, navigate }));
        }
    });

    const handleStep = (value: number) => () => {
        if (activeStep < steps.length - 1 || (activeStep > 0 && value === -1)) {
            setActiveStep(activeStep + value);
        }
        
        // If on the final step and pressing "Next / Create Account", trigger Formik's onSubmit
        if (activeStep === steps.length - 1 && value === 1) {
            formik.handleSubmit();
        }
    };

    return (
        <div>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <section className='mt-20 space-y-10'>
                <form onSubmit={formik.handleSubmit}> {/* Wrapped execution wrapper context */}
                    <div>
                        {activeStep === 0 ? <BecomeSellerFormStep1 formik={formik}/>: 
                        activeStep === 1 ? <BecomeSellerFormStep2 formik={formik}/> :
                        activeStep === 2 ? <BecomeSellerFormStep3 formik={formik}/> :
                        <BecomeSellerFormStep4 formik={formik} />}
                    </div>
                </form>

                <div className='flex items-center justify-between'>
                    <Button onClick={handleStep(-1)} variant="contained" disabled={activeStep === 0}>
                        Back
                    </Button>
                    <Button onClick={handleStep(1)} variant="contained">
                        {activeStep === steps.length - 1 ? "Create Account" : "Next"}
                    </Button>
                </div>
            </section>
        </div>
    );
};

export default SellerAccountForm;